import { z } from 'zod';

export const resultsTourGeneralEnvDtoSchema = z
  .object({
    score: z.number(),
    maxScore: z.number(),
    topics: z.object({
      COMMUNICATION: z.object({
        score: z.number(),
        maxScore: z.number(),
        sections: z.object({
          DIGITAL_COMMUNICATION: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          PHYSICAL_COMMUNICATION: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
        }),
      }),
      FOOD_BEVERAGES: z.object({
        score: z.number(),
        maxScore: z.number(),
        sections: z.object({
          CATERING: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          BEVERAGES: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          DISHES: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
        }),
      }),
      PUBLIC_ENGAGEMENT: z.object({
        score: z.number(),
        maxScore: z.number(),
        sections: z.object({
          PUBLIC_INFORMATION: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          PARTNERSHIP_STRATEGY: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
        }),
      }),
      RESOURCES_POLLUTION: z.object({
        score: z.number(),
        maxScore: z.number(),
        sections: z.object({
          WATER: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          ENERGY: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          WASTE_ECODESIGN: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          POLLUTION_LOCATION: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          WATER_AND_WASTE: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
        }),
      }),
      EQUIPMENT_AND_SCENOGRAPHY: z.object({
        score: z.number(),
        maxScore: z.number(),
        sections: z.object({
          SCENOGRAPHY: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          TECHNIQUE: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
        }),
      }),
    }),
  })
  .optional();
